<template>
  <div>
    <div class="banner">
      <div class="banner-wrapper">
        <v-container class="full-width">
          <v-row>
            <v-col class="no-padding">
              <Logo />
            </v-col>
            <v-col class="align-right">
              <h2>{{ $store.state.hackathonName }}</h2>
              <v-btn
                v-if="isAuthorized && isLoggedIn"
                to="/"
                class="header-link"
                text
              >
                Events
              </v-btn>
              <v-btn
                v-if="isAuthorized && isLoggedIn"
                :to="committeeLink"
                class="header-link"
                text
              >
                Committee
              </v-btn>
              <v-btn
                :to="faqLink"
                class="header-link"
                text
              >
                FAQ
              </v-btn>

              <v-btn
                v-if="(isAuthorized && isLoggedIn) && isAdmin"
                :to="adminLink"
                class="header-link"
                text
              >
                Admin interface
              </v-btn>
              <v-btn
                v-if="isAuthorized && isLoggedIn"
                class="header-link"
                text
                @click="logout($event)"
              >
                Log out
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <div class="master-wrapper">
      <div
        id="app"
        data-app
      >
        <router-view
          class="view-wrapper"
          :app-uuid="uuid"
          :current-user="currentUser"
        />
        <v-container class="full-width footer-wrapper">
          <v-row>
            <v-col cols="12">
              Have a great idea for the ACV Hackathon site?
              <br>Visit <a
                href="https://github.com/acv-auctions/hackathon"
                target="_blank"
              >https://github.com/acv-auctions/hackathon</a> and submit (or check out) an issue!
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import Logo from '@/components/Logo.vue';

export default {
  name: 'App',
  components: {
    Logo,
  },
  computed: {
    ...mapGetters({
      currentHackathonId: 'currentHackathonId',
      currentRefreshToken: 'currentRefreshToken',
      currentUser: 'currentUser',
      isAuthorized: 'isAuthorized',
      isLoggedIn: 'isLoggedIn',
    }),
    adminLink() {
      return `/${this.currentHackathonId}/admin`;
    },
    committeeLink() {
      return { name: 'Committee' };
    },
    faqLink() {
      return { name: 'FAQ' };
    },
    isAdmin() {
      return this.currentUser.isAdmin || false;
    },
  },
  created() {
    this.createUuid();
  },
  methods: {
    logout() {
      this.$store.dispatch('logOutUser');
      if (this.$router !== undefined) {
        this.$router.push('/logout');
      }
    },
    createUuid() {
      this.uuid = uuidv4();
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align: left;
  padding: 1em;
}

::v-deep {
  #app a, a.header-link,
  #app a:active, a.header-link:active,
  #app a:visited, a.header-link:visited,
  #app a:link, a.header-link:link,
  #app a:focus, a.header-link:focus,
  .header-link > .v-btn__content {
    color: #004e7d;
    text-decoration: none;
    font-weight: 600;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
  }

  h2 {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-weight: bold;
    font-size: 24px;
    margin-top: 1rem;
  }
}

.align-right {
  text-align: right;
}

.master-wrapper,
.banner-wrapper {
  max-width: 1400px;
  margin: 0 auto;
}

.banner-wrapper {
  padding: 3em 2em 1em 2em;
}

.full-width {
  max-width: 100%;
}

.no-padding {
  padding: 0;
}

.footer-wrapper {
  padding-top: 3rem;
}
</style>
